import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ar from './ar.json';

export type Locale = 'en' | 'ar';
const STORAGE_KEY = 'mnc.locale';

export function storedLocale(): Locale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'ar' || v === 'en' ? v : null;
  } catch {
    return null;
  }
}

export function applyLocale(locale: Locale): void {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
  if (i18n.language !== locale) void i18n.changeLanguage(locale);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: storedLocale() ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

applyLocale((i18n.language as Locale) ?? 'en');

export default i18n;

/** Pick the localised member of a bilingual pair. */
export function pick(locale: string, en: string | null | undefined, ar: string | null | undefined): string {
  return (locale === 'ar' ? ar || en : en || ar) ?? '';
}
